import { finishCommunication, logout } from "@functions/chat-controller/chatController";
import { cleanAppointmentCheck } from "@redux/slices/appoinments/appointmentCheckIn.slice";
import { cleanAppointment } from "@redux/slices/appoinments/appointments.slice";
import { cleanConsultingRooms } from "@redux/slices/appoinments/consulting-rooms";
import { cleanInfo } from "@redux/slices/appoinments/create-appointment";
import { cleanOrderData } from "@redux/slices/appoinments/document-device-order.slice";
import { cleanPractitionerAppointments } from "@redux/slices/appoinments/practitionerAppointments.slice";
import { cleanPractitionerAppointmentsToBeConfirmed } from "@redux/slices/appoinments/practitionerAppointmentsToBeConfirmed.slice";
import { cleanCalendarHeaderState } from "@redux/slices/calendar/header/calendar-header.slice";
import { cleanChildRecord } from "@redux/slices/child/child-record";
import { setDocs } from "@redux/slices/documents/documents.slice";
import { cleanOrganizationSlice } from "@redux/slices/organization/related-organizations-slice";
import { cleanEthnicitys } from "@redux/slices/patient/ethnicity.slice";
import { setPatientDetailTabDefault } from "@redux/slices/patient/patient-detail.slice";
import { resetPatientDiagnoses } from "@redux/slices/patient/patient-diagnoses.slice";
import { resetPatient } from "@redux/slices/patient/patient-profile.slice";
import { cleanPractitionerModules } from "@redux/slices/practitioner/practitioner-modules";
import { cleanOrganizationDefault } from "@redux/slices/practitioner/practitioner-organization";
import { cleanRecords } from "@redux/slices/records/records.slice";
import { cleanRecordId } from "@redux/slices/records/selected-record.slice";
import { cleanRedeemCurrentState } from "@redux/slices/redeemCurrentState";
import { logOut } from "@redux/slices/session-slice";
import { cleanChatSocketQueue } from "@redux/slices/socketChat/chatChats";
import { cleanContactSocketQueue } from "@redux/slices/socketChat/chatContacts";
import { setChatNewMessageFlagClean } from "@redux/slices/socketChat/chatMessageArrive-slice";
import { cleanChatContactStatus } from "@redux/slices/socketChat/chatStatus";
import { cleanUnreadMessages } from "@redux/slices/socketChat/chatUnreadMessages";
import { setLogged } from "@redux/slices/socketChat/loggedValidation";
import { setChatSocketState, setContactsSocketState } from "@redux/slices/socketChat/storeForRender/chatSocketState";
import { cleanPregnancy } from "@redux/slices/woman/pregnancy";
import { useDispatch } from "react-redux";


const useCleanRedux = () => {
    const dispatch = useDispatch();
    const cleanChatSlices = () => {
        dispatch(setChatSocketState([]));
        dispatch(setChatNewMessageFlagClean())
        dispatch(setContactsSocketState([]))
        dispatch(cleanContactSocketQueue([]));
        dispatch(cleanChatSocketQueue());
        dispatch(cleanUnreadMessages());
        dispatch(setLogged(false))
    }
    const cleanPatientSlices = () => {
        dispatch(cleanEthnicitys());
        dispatch(resetPatient());
        dispatch(setPatientDetailTabDefault());
        dispatch(resetPatientDiagnoses());
        dispatch(cleanPractitionerModules());
    }
    const cleanReducers = async() =>{
        dispatch(logOut());
        dispatch(cleanAppointmentCheck());
        dispatch(cleanConsultingRooms());
        dispatch(cleanPractitionerAppointments());
        dispatch(cleanPractitionerAppointmentsToBeConfirmed());
        dispatch(cleanCalendarHeaderState());
        dispatch(cleanChildRecord());
        dispatch(cleanOrganizationSlice());
        dispatch(setDocs([]));
        dispatch(cleanInfo());
        dispatch(cleanRecords());
        dispatch(cleanRecordId());
        dispatch(cleanPregnancy());
        dispatch(cleanRedeemCurrentState());
        dispatch(cleanAppointment());
        dispatch(cleanOrganizationDefault());
        dispatch(cleanOrderData());
        cleanPatientSlices()
        cleanChatSlices()
        cleanChatContactStatus()
        logout({})
        finishCommunication();
    }

    return { cleanReducers: cleanReducers}
}

export default useCleanRedux
